<template>
  <fieldset class="fieldset__third fieldset open">
      <legend @click="openLegend()">{{$t("form.thirdFieldset.title")}} <svg class="arrow" xmlns="http://www.w3.org/2000/svg" width="16" height="8" viewBox="0 0 16 8">
        <path id="Path_53" data-name="Path 53" d="M7,10l8,8,8-8Z" transform="translate(-7 -10)" fill="#7ac323"/>
      </svg></legend>
      <slide-up-down v-model="this.legendStatus" :duration="400">
        <div class="fieldset__third--wrapper fieldset__wrapper open" id="fieldset__third--wrapper">
        <div class="prijscalc__fieldset-inner inner--first" :class="{invalid:this.onderwerpValidity == 'invalid'}">
          <h3>{{$t("form.thirdFieldset.labelOnderwerp")}}</h3>
          <div class="prijscalc__form-item">
            <div class="fieldcalc__onderwerp--inner">
              <textarea id="prijscalc__subject" name="prijscalc__subject" maxlength="60" :placeholder="$t('form.thirdFieldset.placeholderDescription')" @blur="validateFields(this.onderwerp, 'onderwerpValidity'),elementChecked(),sendValues()" v-model="onderwerp"></textarea>
              <i class="fi-cnsuxl-exclamation-mark"></i>
              <div class="error-message">
                 <small>{{$t("form.validation.onderwerp")}}</small>
              </div>
             </div>
             <div class="fieldset__second--intro">{{$t("form.thirdFieldset.onderwerp")}}</div>
          </div>
        </div>
        <div class="prijscalc__fieldset-inner inner--second">
          <h3>{{$t("form.thirdFieldset.labelGegevens")}}</h3>
          <div class="inner--second__inner">
            <div class="prijscalc__form-item prijscalc_bedrijfsnaam" :class="{invalid:this.companyNameValidity == 'invalid'}">
              <label for="prijscalc_bedrijfsnaam">{{$t("form.thirdFieldset.labelBedrijfsnaam")}}</label>
              <input type="text" id="prijscalc_bedrijfsnaam" name="prijscalc_bedrijfsnaam" maxlength="60" v-model="companyName" @blur="validateFields(this.companyName, 'companyNameValidity'),elementChecked(),sendValues()" required>
              <div class="error-message">
                <small>{{$t("form.validation.companyName")}}</small>
              </div>
               <i class="fi-cnsuxl-exclamation-mark"></i>
            </div>
            <div class="prijscalc__form-item prijscalc_taal" :class="{invalid:this.companyNameValidity == 'invalid'}">
              <label for="prijscalc_prijscalc_taal">{{$t("form.thirdFieldset.labelTaal")}}</label>
               <div class="tooltip__wrapper">
                <svg class="tooltip__trigger" xmlns="http://www.w3.org/2000/svg" width="13.333" height="13.333" viewBox="0 0 13.333 13.333">
                <path id="Icon_material-info" data-name="Icon material-info" d="M8,1.333A6.667,6.667,0,1,0,14.667,8,6.669,6.669,0,0,0,8,1.333Zm.667,10H7.333v-4H8.667ZM8.667,6H7.333V4.667H8.667V6Z" transform="translate(-1.333 -1.333)" fill="#7ac323"/></svg>
                <div class="tooltip">
                  <div class="tooltip__text">{{$t('form.thirdFieldset.taalTooltop')}}</div>
                </div>
              </div>
               <select id="prijscalc_prijscalc_taal" name="prijscalc_prijscalc_taal" v-model="language">
                <option value="NL">NL</option>
                <option value="FR">FR</option>
              </select>
              <svg class="arrow" xmlns="http://www.w3.org/2000/svg" width="16" height="8" viewBox="0 0 16 8">
                <path id="Path_53" data-name="Path 53" d="M7,10l8,8,8-8Z" transform="translate(-7 -10)" fill="#7ac323"/>
              </svg>
               <i class="fi-cnsuxl-exclamation-mark"></i>
            </div>
            <div class="prijscalc__form-item prijscalc_venootschapsvorm">
              <label for="prijscalc_venootschapsvorm">{{$t("form.thirdFieldset.labelVenootschapsvorm")}}</label>
              <select id=prijscalc_venootschapsvorm v-if="$i18n.locale == 'nl'" name="prijscalc_venootschapsvorm" v-model="companyType" @change="vatException(),sendValues()">
                <option value="VZW">VZW</option>
                <option value="NV">NV</option>
                <option value="BV">BV</option>
                <option value="CV">CV</option>
                <option value="VOF">VOF</option>
                <option value="CommV">CommV</option>
              </select>
               <select id=prijscalc_venootschapsvorm v-else name="prijscalc_venootschapsvorm" v-model="companyType" @change="vatException(),sendValues()">
                <option value="ASBL">ASBL</option>
                <option value="SA">SA</option>
                <option value="SRL">SRL</option>
                <option value="SC">SC</option>
                <option value="SNC">SNC</option>
                <option value="SCS">SCS</option>
              </select>
              <svg class="arrow" xmlns="http://www.w3.org/2000/svg" width="16" height="8" viewBox="0 0 16 8">
                <path id="Path_53" data-name="Path 53" d="M7,10l8,8,8-8Z" transform="translate(-7 -10)" fill="#7ac323"/>
              </svg>

            </div>
            <div class="prijscalc__form-item prijscalc_vat" :class="[{invalid:this.vatNrValidity == 'invalid'}]">
              <label for="prijscalc_vat">{{$t("form.thirdFieldset.labelVat")}}</label>
              <div class="tooltip__wrapper">
                <svg class="tooltip__trigger" xmlns="http://www.w3.org/2000/svg" width="13.333" height="13.333" viewBox="0 0 13.333 13.333">
                <path id="Icon_material-info" data-name="Icon material-info" d="M8,1.333A6.667,6.667,0,1,0,14.667,8,6.669,6.669,0,0,0,8,1.333Zm.667,10H7.333v-4H8.667ZM8.667,6H7.333V4.667H8.667V6Z" transform="translate(-1.333 -1.333)" fill="#7ac323"/></svg>
                <div class="tooltip">
                  <div class="tooltip__text">{{$t('form.thirdFieldset.vatTooltip')}}</div>
                </div>
              </div>
              <input type="text" id="prijscalc_vat" name="prijscalc_vat" placeholder="BE 0843937163" v-model="vatNr" :disabled="this.vatExceptionVal" @blur="validateVAT(),elementChecked(),sendValues()" required>
              <div class="error-message">
                <small>{{$t("form.validation.vat")}}</small>
              </div>
              <i class="fi-cnsuxl-exclamation-mark"></i>
            </div>
            <div id="prijscalc__address" class="prijscalc__address">
              <div class="prijscalc__form-item prijscalc_straat" :class="{invalid:this.streetValidity == 'invalid'}">
                <label for="prijscalc_straat">{{$t("form.thirdFieldset.labelStraat")}}</label>
                <input type="text" id="prijscalc_straat" name="prijscalc_straat" v-model="street" @blur="validateFields(this.street, 'streetValidity'),elementChecked(),sendValues()" required>
                <div class="error-message">
                  <small>{{$t("form.validation.street")}}</small>
                </div>
                 <i class="fi-cnsuxl-exclamation-mark"></i>
              </div>
              <div class="prijscalc__form-item prijscalc_nummer" :class="{invalid:this.streetNumberValidity == 'invalid'}">
                <label for="prijscalc_nummer">{{$t("form.thirdFieldset.labelNummer")}}</label>
                <input type="number" id="prijscalc_nummer" name="prijscalc_nummer" v-model="streetNumber" @blur="validateFields(this.streetNumber, 'streetNumberValidity'),elementChecked(),sendValues()" required>
                <i class="fi-cnsuxl-exclamation-mark"></i>
              </div>
              <div class="prijscalc__form-item prijscalc_bus">
                <label for="prijscalc_bus">{{$t("form.thirdFieldset.labelBus")}}</label><span class="optional">({{$t("form.optioneel")}})</span>
                <input type="text" id="prijscalc_bus" name="prijscalc_bus" v-model="boxNr" @blur="elementChecked(),sendValues()">
              </div>
               <div class="prijscalc__form-item prijscalc_postcode" :class="{invalid:this.zipCodeValidity == 'invalid'}">
                <label for="prijscalc_postcode">{{$t("form.thirdFieldset.labelPostcode")}}</label>
                <input type="text@" id="prijscalc_postcode" name="prijscalc_postcode" v-model="zipCode" @click="lookUpPostalCode()" @input="lookUpPostalCode()" @blur="validateFields(this.zipCode, 'zipCodeValidity'),elementChecked(),sendValues()" required>
                <ul v-if="showPostalCodes == true" class="prijscalc__zipCodeList" @mouseleave="showPostalCodes = false">
                  <li class="suggestion" v-for="(zipcode, zip) in zipCodeList" :key="zip.postalcode" @click="addPostalCode(zipcode.postalcode,zipcode.city)">{{zipcode.postalcode+'-'+zipcode.city}}</li>
                </ul>
                <i class="fi-cnsuxl-exclamation-mark"></i>
              </div>
              <div class="prijscalc__form-item prijscalc_gemeente" :class="{invalid:this.cityValidity == 'invalid'}">
                <label for="prijscalc_gemeente">{{$t("form.thirdFieldset.labelGemeente")}}</label>
                <input type="text" id="prijscalc_gemeente" name="prijscalc_gemeente" maxlength="40" v-model="city" @click="lookUpCity()" @input="lookUpCity()" @blur="validateFields(this.city, 'cityValidity'),elementChecked(),sendValues()" required>
                 <ul  v-if="showCities == true" class="prijscalc__zipCodeList" @mouseleave="showCities = false">
                  <li class="suggestion" v-for="(zipcode, zip) in zipCodeList" :key="zip.postalcode" @click="addCity(zipcode.postalcode,zipcode.city)">{{zipcode.postalcode+'-'+zipcode.city}}</li>
                </ul>
                <div class="error-message">
                  <small>{{$t("form.validation.city")}}</small>
                </div>
                <i class="fi-cnsuxl-exclamation-mark"></i>
              </div>
              <div class="prijscalc__form-item prijscalc_land" :class="{invalid:this.countryValidity == 'invalid'}">
                <label for="prijscalc_land">{{$t("form.thirdFieldset.labelLand")}}</label>
                <!-- <input type="text" id="prijscalc_land" name="prijscalc_land" v-model="country" @blur="validateFields(this.country, 'countryValidity'),validateAddress(),elementChecked(),sendValues()" required> -->
                <select id="prijscalc_land" name="prijscalc_land" v-model="country" @change="getCountries(this.country),validateCountry(),elementChecked(),sendValues()" required>
                  <option v-for="(country, c) in countries" :key="c" :value="country.code">{{country.name}}</option>
                </select>
                <svg class="arrow" xmlns="http://www.w3.org/2000/svg" width="16" height="8" viewBox="0 0 16 8">
                <path id="Path_53" data-name="Path 53" d="M7,10l8,8,8-8Z" transform="translate(-7 -10)" fill="#7ac323"/>
                </svg>
                <div class="error-message">
                  <small>{{$t("form.validation.country")}}</small>
                </div>
                <i class="fi-cnsuxl-exclamation-mark"></i>
              </div>
              <div class="error-message-address">
                <i class="fi-cnsuxl-exclamation-mark"></i>
                <small>{{$t("form.validation.address")}}</small>
              </div>
            </div>
            <div class="prijscalc__form-item prijscalc_voornaam">
              <label for="prijscalc_voornaam">{{$t("form.thirdFieldset.labelVoornaam")}}</label><span class="optional">({{$t("form.optioneel")}})</span>
              <input type="text" id="prijscalc_voornaam" name="prijscalc_voornaam" maxlength="60" v-model="firstName" @blur="sendValues()" required>
            </div>
            <div class="prijscalc__form-item prijscalc_achternaam" :class="{invalid:this.lastNameValidity == 'invalid'}">
              <label for="prijscalc_achternaam">{{$t("form.thirdFieldset.labelAchternaam")}}</label>
              <input type="text" id="prijscalc_achternaam" name="prijscalc_achternaam" maxlength="60" v-model="lastName" @blur="validateFields(this.lastName, 'lastNameValidity'),elementChecked(),sendValues()" required>
              <div class="error-message">
                <small>{{$t("form.validation.lastName")}}</small>
              </div>
              <i class="fi-cnsuxl-exclamation-mark"></i>
            </div>
            <div class="prijscalc__form-item prijscalc_email" :class="{invalid:this.emailValidity == 'invalid'}">
              <label for="prijscalc_email">{{$t("form.thirdFieldset.labelEmail")}}</label>
              <input type="email" id="prijscalc_email" name="prijscalc_email" v-model="email" @blur="validateEmail(),elementChecked(),sendValues()" required>
              <div class="error-message">
                <small>{{$t("form.validation.email")}}</small>
              </div>
              <i class="fi-cnsuxl-exclamation-mark"></i>
            </div>
            <div class="prijscalc__form-item prijscalc_telefoon" :class="{invalid:this.phoneNrValidity == 'invalid'}">
              <label for="prijscalc_telefoon">{{$t("form.thirdFieldset.labelTelefoon")}}</label>
              <input type="tel" id="prijscalc_telefoon" name="prijscalc_telefoon" v-model="phoneNr" @blur="validatePhoneNumber(),elementChecked(),sendValues()" required>
              <div class="error-message">
                <small>{{$t("form.validation.phoneNr")}}</small>
              </div>
              <i class="fi-cnsuxl-exclamation-mark"></i>
            </div>
            <div class="prijscalc__form-item prijscalc_referentie">
              <label for="prijscalc_referentie">{{$t("form.thirdFieldset.labelReferentie")}}</label><span class="optional">({{$t("form.optioneel")}})</span>
              <input type="tel" id="prijscalc_referentie" name="prijscalc_referentie" maxlength="60" v-model="customerRef" @blur="sendValues()">
            </div>
            <div class="prijscalc__form-item prijscalc_opmerking">
              <label for="prijscalc_opmerking">{{$t("form.thirdFieldset.labelOpmerkingen")}}</label><span class="optional">({{$t("form.optioneel")}})</span>
              <textarea id="prijscalc_opmerking" name="prijscalc_opmerking" maxlength="255" v-model="remark" @blur="sendValues()"></textarea>
            </div>
          </div>
        </div>
       </div>
     </slide-up-down>
    </fieldset>
</template>

<script>
import axios from 'axios';
export default {
  props: {
    validationThird:{
      type: String,
    },
  },
  data(){
    return{
      onderwerp: '',
      onderwerpValidity: '',
      onderwerpChecked: '',
      companyName: '',
      companyNameValidity: '',
      companyNameChecked:'',
      companyType: '',
      vatNr: '',
      vatNrValidity: '',
      vatNrChecked: '',
      street: '',
      streetValidity: '',
      streetChecked: '',
      streetNumber: '',
      streetNumberValidity: '',
      streetNumberChecked: '',
      zipCode: '',
      zipCodeValidity: '',
      zipCodeChecked: '',
      zipCodeList:[],
      zipCodeAdded: '',
      boxNr: '',
      city:'',
      cityValidity: '',
      cityChecked: '',
      cityList:[],
      remark: '',
      customerRef: '',
      phoneNr: '',
      phoneNrValidity: '',
      phoneNrChecked: '',
      email: '',
      emailValidity: '',
      emailChecked: '',
      lastName: '',
      lastNameValidity: '',
      lastNameChecked: '',
      firstName: '',
      country: 'BEL',
      countries:[],
      countryValidity: '',
      countryChecked: '',
      status: 'hold',
      checked: 'unchecked',
      secondStatus:'',
      visibility: 'open',
      weight: '',
      addressValidityCheck: "",
      countriesLoaded: false,
      vatExceptionVal: false,
      showPostalCodes: false,
      showCities: false,
      legendStatus: true,
      language: ''
    }
  },
  mounted: async function(){
    this.getCountries('onMount');
    this.vatException();
    this.defaultVat();
    this.getDefaultLang();
  },
  watch: {
    validationThird(value){
       if(value === "hold"){
        this.checkValidity();
      }
    },
  },
  methods: {
    getDefaultLang(){
      if(this.$i18n.locale == 'nl'){
        this.language = 'NL';
      }else{
        this.language = 'FR';
      }
    },
     openLegend(){
      this.legendStatus = !this.legendStatus;
    },
    vatException(){
      if(this.companyType == "VZW" || this.companyType == "ASBL"){
        this.vatNrValidity = "valid";
        this.vatNrChecked = "checked";
        this.vatExceptionVal = true;
      }else if(this.vatNr == ""){
        this.vatExceptionVal = false;
        this.vatNrChecked = 'checked';
        this.vatNrValidity = 'invalid';
      }
      this.vatNr = "";
    },
    defaultVat(){
      if(this.$i18n.locale == 'nl'){
        this.companyType = 'VZW';
      }else{
        this.companyType = 'ASBL';
      }
      this.vatException();
    },
    getCountries(timing){
      let lang = this.$i18n.locale;
      let table = "";
      this.zipCode = "";
      this.city = "";
      this.zipCodeList = [];
      this.zipCodeValidity = "";
      this.cityValidity = "";
      if(lang == 'nl'){
        table = "konnu_landencodes_nl";
      }else{
        table = "konnu_landencodes_fr";
      }
      if(timing == "onMount" || timing == "load"){
      var host = 'https://'+window.location.host+'/';
        if(this.countriesLoaded == false){
          axios.get(host+'get-countries?input='+table+"&timing="+timing)
            .then(response => {
              let length = response.data.length;
                // Get COUNTRIES
              if(length > 0){
                response.data.forEach((element) => {
                  this.countries.push({"code":element.code,"name":element.name});
                })
              }
              if(timing == 'load'){
                this.countriesLoaded = true;
              }
            })
            .catch((error) =>{
              console.log(error);
            })
        }
       }
    },
    lookUpPostalCode(){
      if(this.country == "BEL" || this.country == "NLD" || this.country == 'LUX' || this.country == "FRA" || this.country == "DEU"){
        let char = this.zipCode.length;
        this.zipCodeValidity = "invalid";
        if(char >= 4){
           let host = 'https://'+window.location.host+'/';
           axios.get(host+'get-postalcode?input='+this.zipCode+'&countryCode='+this.country)
            .then(response => {
              this.showPostalCodes = true;
              this.zipCodeList = response.data;
            })
            .catch((error) =>{
              this.showPostalCodes = false;
              console.log(error);
            })
        }
      }
    },
    addPostalCode(zipCode,city){
      if(this.country == "BEL" || this.country == "NLD" || this.country == 'LUX' || this.country == "FRA" || this.country == "DEU"){
        this.zipCode = zipCode;
        this.city = city;
        this.showPostalCodes = false;
        this.zipCodeValidity = "valid";
        this.cityValidity = "valid";
     }

    },
    lookUpCity(){
      if(this.country == "BEL" || this.country == "NLD" || this.country == 'LUX' || this.country == "FRA" || this.country == "DEU"){
        let char = this.city.length;
        this.cityValidity = "invalid";
        if(char >= 4){
           let host = 'https://'+window.location.host+'/';
           axios.get(host+'get-city?input='+this.city+'&countryCode='+this.country)
            .then(response => {
              this.showCities = true;
              this.zipCodeList = response.data;
            })
            .catch((error) =>{
              this.showCities = false;
              console.log(error);
            })
        }
      }
    },
    addCity(zipCode,city){
      if(this.country == "BEL" || this.country == "NLD" || this.country == 'LUX' || this.country == "FRA" || this.country == "DEU"){
        this.zipCode = zipCode;
        this.city = city;
        this.showCities = false;
        this.zipCodeValidity = "valid";
        this.cityValidity = "valid";
      }
    },
  /* validateAddress(){
        if(this.street != '' && this.streetNumber != '' && this.zipCode != '' && this.city != '' && this.country != ''){
          var query = this.street+"+"+this.streetNumber+'+'+this.zipCode+'+'+this.city+'&in=countryCode:'+this.country;
        axios.get('https://geocode.search.hereapi.com/v1/geocode?q='+query+'&apiKey=lti2VnaLpXwn3f2NGA9KKBWvQVW22Gf_24BoVajeOBI')
          .then((result) => {
              if(result.data.items.length == 1){
                if(result.data.items[0].scoring.fieldScore.streets !== undefined && result.data.items[0].scoring.fieldScore.houseNumber !== undefined && result.data.items[0].scoring.fieldScore.postalCode !== undefined){
                  if(result.data.items[0].scoring.queryScore >= 0.9){
                    this.addressValidityCheck = "valid";
                  }else{
                    this.addressValidityCheck = "invalid";
                  }
                }else{
                  this.addressValidityCheck = "invalid";
                }
              }
              else{
                this.addressValidityCheck = "invalid";
              }
             })
              .catch((error) =>{
                console.log(error);
            })
      }

    },*/
    validateFields(val, validyVal){
      if(val === "" ){
        switch(validyVal) {
          case 'onderwerpValidity':
            this.onderwerpValidity = 'invalid';
            this.status = "hold";
          break;
          case 'companyNameValidity':
            this.companyNameValidity = 'invalid';
            this.status = "hold";
          break;
          case 'vatNrValidity':
            this.vatNrValidity = 'invalid';
            this.status = "hold";
          break;
          case 'streetValidity':
            this.streetValidity = 'invalid';
            this.status = "hold";
          break;
          case 'streetNumberValidity':
            this.streetNumberValidity = 'invalid';
            this.status = "hold";
          break;
          case 'zipCodeValidity':
            if(this.country != "BEL" || this.country != "NLD" || this.country != 'LUX' || this.country != "FRA" || this.country != "DEU"){
              this.zipCodeValidity = 'invalid';
              this.status = "hold";
            }
          break;
          case 'cityValidity':
            if(this.country != "BEL" || this.country != "NLD" || this.country != 'LUX' || this.country != "FRA" || this.country != "DEU"){
              this.cityValidity = 'invalid';
              this.status = "hold";
            }
          break;
          case 'countryValidity':
            this.countryValidity = 'invalid';
            this.status = "hold";
          break;
          case 'lastNameValidity':
            this.lastNameValidity = 'invalid';
            this.status = "hold";
          break;
        }
      }else{
        switch(validyVal) {
          case 'onderwerpValidity':
            this.onderwerpValidity = 'valid';
            this.onderwerpChecked = "checked";
          break;
          case 'companyNameValidity':
            this.companyNameValidity = 'valid';
            this.companyNameChecked = "checked";
          break;
          case 'vatNrValidity':
            this.vatNrValidity = 'valid';
            this.vatNrChecked = "checked";
          break;
          case 'streetValidity':
            this.streetValidity = 'valid';
            this.streetChecked = "checked";
          break;
          case 'streetNumberValidity':
            this.streetNumberValidity = 'valid';
            this.streetNumberChecked = "checked";
          break;
          case 'zipCodeValidity':
            if(this.country != "BEL" && this.country != "NLD" && this.country != 'LUX' && this.country != "FRA" && this.country != "DEU"){
              this.zipCodeValidity = 'valid';
              this.zipCodeChecked = "checked";
            }
          break;
          case 'cityValidity':
            if(this.country != "BEL" && this.country != "NLD" && this.country != 'LUX' && this.country != "FRA" && this.country != "DEU"){
              this.cityValidity = 'valid';
              this.cityChecked = 'checked';
            }
          break;
          case 'countryValidity':
            this.countryValidity = 'valid';
            this.countryChecked = 'checked';
          break;
          case 'lastNameValidity':
            this.lastNameValidity = 'valid';
            this.lastNameChecked = 'checked';
          break;
        }
      }
    },
    validatePhoneNumber(){
      var re = /^(((\+|00)32[ ]?(?:\(0\)[ ]?)?)|0){1}(4(60|[789]\d)\/?(\s?\d{2}\.?){2}(\s?\d{2})|(\d\/?\s?\d{3}|\d{2}\/?\s?\d{2})(\.?\s?\d{2}){2})$/;
        var result = re.test(this.phoneNr);
        if(result === false || this.phoneNr === ""){
          this.phoneNrValidity = 'invalid';
          this.status = 'hold';
        }else{
          this.phoneNrValidity = 'valid';
          this.phoneNrChecked = "checked";
        }
    },
    validateVAT(){
      var re = /(BE)?0[0-9]{9}$/;
      var result = re.test(this.vatNr);
        if(result === false || this.vatNr === ""){
          this.vatNrValidity = 'invalid';
          this.status = 'hold';
        }else{
          this.vatNrValidity = 'valid';
          this.vatNrChecked = "checked";
        }
    },
    validateCountry(){
      if(this.country == "load"){
        this.countryValidity = 'invalid';
      }else{
        this.countryValidity = 'valid';
      }

    },
    validateEmail() {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      var test = re.test(this.email);
      if(this.email === "" || test === false){
        this.emailValidity = 'invalid';
         this.status = 'hold';
      }else{
        this.emailValidity = 'valid';
        this.emailChecked = "checked";
      }
      return re.test(this.email);
    },
    elementChecked(){
      if(this.onderwerpValidity == 'valid' && this.companyNameValidity == 'valid' && this.vatNrValidity == 'valid' && this.streetValidity == 'valid' && this.streetNumberValidity == 'valid'&& this.zipCodeValidity == 'valid' && this.cityValidity == 'valid' && this.lastNameValidity == 'valid' && this.emailValidity == 'valid' && this.phoneNrValidity == 'valid'){
        this.checked = "checked";
        this.status = "go";
      }else{
        this.checked = "unchecked";
        this.status = "hold";
      }
    },
    checkValidity(){
      this.status = "go";
      this.secondStatus = "";
      //if(this.allValid == true){}
      if(this.phoneNrValidity == 'invalid' || this.phoneNrValidity == ""){
        this.status = "hold";
        this.phoneNrValidity = 'invalid';
        this.scrollToElement("#prijscalc_telefoon");
      }
      if(this.emailValidity == 'invalid' || this.emailValidity == ""){
        this.status = "hold";
        this.emailValidity = 'invalid';
        this.scrollToElement("#prijscalc_email");
      }
      if(this.lastNameValidity == 'invalid' || this.lastNameValidity == ""){
        this.status = "hold";
        this.lastNameValidity = 'invalid';
        this.scrollToElement("#prijscalc_achternaam");
      }
      if(this.cityValidity == 'invalid' || this.cityValidity == ""){
        this.status = "hold";
        this.cityValidity = 'invalid';
        this.scrollToElement("#prijscalc_gemeente");
      }
      if(this.zipCodeValidity == 'invalid' || this.zipCodeValidity == ""){
        this.status = "hold";
        this.zipCodeValidity = 'invalid';
        this.scrollToElement("#prijscalc_postcode");
      }
      if(this.streetNumberValidity == 'invalid' || this.streetNumberValidity == ""){
        this.status = "hold";
        this.streetNumberValidity = 'invalid';
        this.scrollToElement("#prijscalc_nummer");
      }
      if(this.streetValidity == 'invalid' || this.streetValidity == ""){
        this.status = "hold";
        this.streetValidity = 'invalid';
        this.scrollToElement("#prijscalc_straat");
      }
      if(this.vatNrValidity == 'invalid' || this.vatNrValidity == ""){
        this.status = "hold";
        this.vatNrValidity = 'invalid';
        this.scrollToElement("#prijscalc_vat");
      }
      if(this.companyNameValidity == 'invalid' || this.companyNameValidity == ""){
        this.status = "hold";
        this.companyNameValidity = 'invalid';
        this.scrollToElement("#prijscalc_bedrijfsnaam");
      }
      if(this.onderwerpValidity == 'invalid' || this.onderwerpValidity == ""){
        this.status = "hold";
        this.onderwerpValidity = 'invalid';
        this.scrollToElement("#prijscalc__subject");
      }
    },
    scrollToElement(id){
      var element = document.querySelector(id);
      const yOffset = 0;
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({top: y, behavior: 'smooth'});
    },
    sendValues(){
      var data = {
        onderwerp : this.onderwerp,
        companyName : this.companyName,
        companyType: this.companyType,
        vatNr: this.vatNr,
        street: this.street,
        streetNumber: this.streetNumber.toString(),
        zipCode: this.zipCode.toString(),
        boxNr: this.boxNr,
        city: this.city,
        remark: this.remark,
        customerRef: this.customerRef,
        phoneNr: this.phoneNr,
        email: this.email,
        lastName: this.lastName,
        firstName: this.firstName,
        country: this.country,
        status : this.status,
        checked: this.checked,
        language: this.language
      };
    // send values to parent when status is GO
      //console.log(this.status);
      if(this.status != 'hold' && this.checked == "checked"){
        this.$emit('values-third', data);
      }else{
        data = {};
        this.$emit('values-third', data);
      }
    }
  }
}
</script>
